module.exports = "<template role=\"div\">\r\n    <slot></slot>\r\n</template>\r\n";